exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dataTableSummary{width:100%;margin-bottom:1em}.dataTableSummary .summaryDateCell{text-align:center;margin-top:1em}.dataTableSummary .summaryCardsContainer{flex-flow:row nowrap;display:flex;justify-content:space-evenly}.dataTableSummary .summaryCard{text-align:center;padding:1em;flex-grow:0;flex-shrink:0;flex-basis:25%}.dataTableSummary .summaryCard .cardContent{box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:.3em;padding:1em}.dataTableSummary .summaryCard.clickable{cursor:pointer}.dataTableSummary .summaryCard .iconContainer{display:flex;flex-flow:row nowrap;justify-content:space-around;align-items:center;height:2em}.dataTableSummary .summaryCard .iconContainer .iconImage{width:1.5em}.dataTableSummary .summaryCard .stat{font-size:2em}.dataTableSummary .caption{display:table-caption;padding:0 1em .3em;color:#d3d3d3;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/data_table_summary.scss
// module id = 1293
// module chunks = 0